module.exports = __webpack_public_path__ + "img/kamezoko-avatar.233546ae.png";